/* eslint-disable no-useless-escape */
import moment from 'moment';
import { createConfirmation } from 'react-confirm';
import ConfirmModal from 'components/ConfirmModal';
import {
  COUNTRY_CODES,
  CURRENCY_CODES,
  MARKET_SSL_IMAGE_URL,
} from './constants';

const validateEmail = (email) => {
  const re =
    /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(email).toLowerCase());
};

export function getMarketLabel(market, suffix = ' Market') {
  const marketLabel = `${market.businessname} ${COUNTRY_CODES[market.countrycode]}${suffix}`;
  if (market.isactive === 0) {
    return '(Inactive) ' + marketLabel;
  }
  return marketLabel;
}

const getMarketInfo = (market) => {
  return {
    value: market.id,
    label: getMarketLabel(market),
    type: !!market.accounttype ? 'vendor' : 'seller',
    countryCode: market.countrycode,
    currency: CURRENCY_CODES[market.countrycode],
    isdsp: market.isdsp,
    mws_granted: market.mws_granted,
    imageDomain: MARKET_SSL_IMAGE_URL[market.countrycode],
    market: market,
  };
};

const showConfirmModal = createConfirmation(ConfirmModal);

const confirm = (confirmation, options = {}) => {
  return showConfirmModal({ confirmation, ...options });
};

const checkIsValidDomain = (domain) => {
  const re = new RegExp(
    /^((?:(?:(?:\w[\.\-\+]?)*)\w)+)((?:(?:(?:\w[\.\-\+]?){0,62})\w)+)\.(\w{2,6})$/,
  );
  return domain.match(re);
};

const isFileImage = (file) => {
  return file && file['type'].split('/')[0] === 'image';
};

const setLSMarket = (marketId) => {
  localStorage.setItem('selectedMarket', marketId);
};

const getLSMarket = () => {
  return localStorage.getItem('selectedMarket');
};

export const getLSDate = () => {
  let startDate = localStorage.getItem('startDate');
  let endDate = localStorage.getItem('endDate');

  startDate = moment(startDate);
  endDate = moment(endDate);
  return [
    startDate.isValid() ? startDate : null,
    endDate.isValid() ? endDate : null,
  ];
};

export const setLSDate = (startDate, endDate) => {
  localStorage.setItem('startDate', startDate);
  localStorage.setItem('endDate', endDate);
};

const currencyFormatter = (value, currency = 'USD', digits = 2) => {
  if (!value) {
    return value;
  }
  return value.toLocaleString('en-US', {
    style: 'currency',
    currency: currency,
    maximumFractionDigits: digits,
    minimumFractionDigits: digits,
  });
};

export const percentageFormatter = (value, digits = 2) => {
  return (
    ((value || 0) * 100).toLocaleString(undefined, {
      maximumFractionDigits: digits,
      minimumFractionDigits: digits,
    }) + '%'
  );
};

export const multipleFormatter = (value, digits = 1) => {
  if (!value) {
    return value;
  }
  return (
    value.toLocaleString(undefined, {
      maximumFractionDigits: digits,
      minimumFractionDigits: digits,
    }) + 'x'
  );
};

export const agCurrencyFormatter = (params) => {
  return (params.value || 0).toLocaleString('en-US', {
    style: 'currency',
    currency: params.context.currency,
  });
};
export const agCurrencyFormatter0 = (params) => {
  return (params.value || 0).toLocaleString('en-US', {
    style: 'currency',
    currency: params.context.currency,
    maximumFractionDigits: 0,
    minimumFractionDigits: 0,
  });
};
export const agCurrencyFormatter1 = (params) => {
  return (params.value || 0).toLocaleString('en-US', {
    style: 'currency',
    currency: params.context.currency,
    maximumFractionDigits: 1,
    minimumFractionDigits: 1,
  });
};
export const agLocalizedFormatter = (params) => {
  return (params.value || 0).toLocaleString();
};

export const agLocalizedFormatter1 = (params) => {
  return (params.value || 0).toLocaleString(undefined, {
    maximumFractionDigits: 1,
    minimumFractionDigits: 1,
  });
};

export const agLocalizedFormatter2 = (params) => {
  return (params.value || 0).toLocaleString(undefined, {
    maximumFractionDigits: 2,
    minimumFractionDigits: 2,
  });
};

export const agPercentageFormatter = (params) => {
  return (
    ((params.value || 0) * 100).toLocaleString(undefined, {
      maximumFractionDigits: 2,
      minimumFractionDigits: 2,
    }) + '%'
  );
};
export const agPercentageFormatter0 = (params) => {
  return (
    ((params.value || 0) * 100).toLocaleString(undefined, {
      maximumFractionDigits: 0,
      minimumFractionDigits: 0,
    }) + '%'
  );
};
export const agPercentageFormatter1 = (params) => {
  return (
    ((params.value || 0) * 100).toLocaleString(undefined, {
      maximumFractionDigits: 1,
      minimumFractionDigits: 1,
    }) + '%'
  );
};

export {
  validateEmail,
  confirm,
  checkIsValidDomain,
  isFileImage,
  setLSMarket,
  getLSMarket,
  currencyFormatter,
  getMarketInfo,
};
